module.exports = __webpack_public_path__ + "img/foto_4.119f28c5.jpg";